module.exports = __webpack_public_path__ + "img/img-i5gam-ct-list14.d45aa23d.png";